import React from 'react'

export const SvgCalendar = ({ width = '24px', height = '24px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
            <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z
                    M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
        </svg>
    );
}

export const SvgCheckFill = ({ width = '24px', height = '24px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 227 222" >
            <path opacity="1.00" d=" M 200.32 15.13 C 206.98 11.87 212.56 6.13 219.76 4.13 C 221.62 5.79 223.11 7.83 224.16 10.09 C 224.10 11.40 222.73 12.08 221.93 12.94 
                C 217.79 16.46 213.09 19.39 209.45 23.45 C 208.27 26.81 208.95 30.50 208.81 34.00 C 208.87 91.67 208.81 149.34 208.84 207.00 
                C 208.81 210.87 209.06 214.75 208.65 218.61 C 140.62 218.78 72.56 218.67 4.52 218.66 C 4.27 154.13 4.53 89.55 4.40 25.00 C 4.38 21.89 4.28 18.77 4.69 15.68 
                C 8.77 15.17 12.90 15.44 17.00 15.42 C 74.34 15.43 131.67 15.42 189.00 15.43 C 192.77 15.35 196.60 15.83 200.32 15.13 M 24.94 35.88 
                C 24.79 37.25 24.69 38.62 24.64 40.00 C 24.69 91.34 24.68 142.67 24.65 194.00 C 24.69 195.29 24.79 196.57 24.95 197.85 C 26.96 198.07 28.99 198.08 31.01 198.08 
                C 83.27 197.84 135.55 198.33 187.80 197.84 C 188.16 172.91 187.84 147.95 187.95 123.00 C 187.83 97.27 188.19 71.52 187.78 45.79 
                C 186.14 46.76 184.68 47.99 183.44 49.43 C 164.07 71.43 146.82 95.21 130.62 119.61 C 121.99 132.91 113.60 146.41 106.66 160.68 
                C 104.69 165.28 99.82 167.26 96.00 170.00 C 89.43 174.22 83.41 179.20 77.18 183.88 C 72.66 170.25 66.93 157.06 60.86 144.06 
                C 56.65 135.40 52.12 126.60 45.10 119.85 C 41.95 116.78 37.82 115.11 34.06 112.96 C 40.83 105.81 48.96 98.85 58.96 97.13 C 64.95 95.96 69.77 100.52 73.23 104.78 
                C 80.31 113.77 84.60 124.51 89.37 134.81 C 90.00 134.00 90.65 133.19 91.25 132.35 C 111.79 99.50 138.16 70.78 165.67 43.70 C 168.31 41.14 171.21 38.81 173.29 35.74 
                C 167.87 35.25 162.43 35.59 157.00 35.53 C 114.34 35.53 71.67 35.61 29.01 35.56 C 27.65 35.60 26.29 35.71 24.94 35.88 Z" />
        </svg>
    );
}

export const SvgCheckEmpty = ({ width = '24px', height = '24px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 227 222" >
            <path opacity="1.00" d=" M 4.00 15.00 C 72.33 15.00 140.66 14.99 209.00 15.00 C 209.00 82.67 209.00 150.33 209.00 218.00 C 140.67 218.00 72.34 218.00 4.00 218.00 
                C 4.00 150.33 4.00 82.67 4.00 15.00 M 24.00 35.00 C 24.00 89.33 24.00 143.66 24.00 198.00 C 79.00 198.00 134.00 198.00 189.00 198.00 
                C 189.00 143.67 189.00 89.34 189.00 35.00 C 134.00 34.99 79.00 35.00 24.00 35.00 Z" />
        </svg>
    );
}

export const SvgCheckMark = ({ width = '32px', height = '48px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.877 101.052" >
            <path d="M4.43,63.63c-2.869-2.755-4.352-6.42-4.427-10.11c-0.074-3.689,1.261-7.412,4.015-10.281 c2.752-2.867,6.417-4.351,10.106-4.425
                c3.691-0.076,7.412,1.255,10.283,4.012l24.787,23.851L98.543,3.989l1.768,1.349l-1.77-1.355 c0.141-0.183,0.301-0.339,0.479-0.466
                c2.936-2.543,6.621-3.691,10.223-3.495V0.018l0.176,0.016c3.623,0.24,7.162,1.85,9.775,4.766 c2.658,2.965,3.863,6.731,3.662,10.412h0.004l-0.016,0.176
                c-0.236,3.558-1.791,7.035-4.609,9.632l-59.224,72.09l0.004,0.004 c-0.111,0.141-0.236,0.262-0.372,0.368c-2.773,2.435-6.275,3.629-9.757,3.569
                c-3.511-0.061-7.015-1.396-9.741-4.016L4.43,63.63 L4.43,63.63z"/>
        </svg>
    );
}

export const SvgEmailSign = ({ width = '32px', height = '32px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
            <path d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862
                c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 
                2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 
                1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 
                1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z"/>
        </svg>
    );
}

export const SvgClose = ({ width = '32px', height = '32px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 
                    1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
    );
}

export const SvgShowPassword = ({ width = '32px', height = '32px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
        </svg>
    );
}
export const SvgHidePassword = ({ width = '32px', height = '32px', fillColor = "currentcolor", className = "" }) => {
    return (
        <svg width={width} height={height} fill={fillColor} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" >
            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5
                    c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
        </svg>
    );
}

//<path />

